/**
 * Chat Widget Integration
 * Handles the BobWebExt chat widget lifecycle
 */

/**
 * Initialize the chat widget
 */
function initChatWidget() {
    const chatLauncher = document.getElementById('chat-widget-launcher');
  
    if (!chatLauncher) {
      console.warn('Chat launcher button not found');
      return;
    }
  
    console.log('Chat launcher found, initializing...');
  
    // Always show the button for testing
    chatLauncher.style.display = 'flex';
    chatLauncher.disabled = false;
  
    // Get widget ID from data attribute
    const chatWidgetId = chatLauncher.dataset.widgetId;
    console.log('Widget ID:', chatWidgetId);
  
    if (!chatWidgetId || chatWidgetId === 'YOUR_EXTENSION_ID') {
      console.warn('Chat widget ID not configured. Please set the data-widget-id attribute.');
      return;
    }
  
    // Check if widget is available
    if (typeof window.BobWebExt === 'undefined') {
      console.warn('BobWebExt not found. Chat widget may not be loaded.');
      console.log('Available window properties:', Object.keys(window).filter(key => key.toLowerCase().includes('bob')));
      return;
    }
  
    console.log('BobWebExt found, checking widget...');
    const widget = window.BobWebExt[chatWidgetId];
  
    if (!widget) {
      console.warn(`Chat widget with ID '${chatWidgetId}' not found.`);
      console.log('Available widgets:', Object.keys(window.BobWebExt));
      return;
    }
  
    // Add custom CSS to position chat widget at top
    addChatWidgetStyles();
  
    // Show the chat button when widget is ready
    widget.ready((instance) => {
      console.log('Chat widget is ready');
      chatLauncher.style.display = 'flex';
      chatLauncher.disabled = false;
    });
  }
  
  /**
   * Add custom styles for chat widget positioning
   */
  function addChatWidgetStyles() {
    const styleId = 'chat-widget-custom-styles';
    if (!document.getElementById(styleId)) {
      const style = document.createElement('style');
      style.id = styleId;
      style.textContent = `
        /* Let BobWebExt handle default positioning - ensure mobile visibility */
        /* Ensure all header icons are visible on mobile */
        .header__icon--chat,
        .header__icon--account,
        .header__icon--cart,
        .header__icon--search {
          display: flex !important;
        }
  
        @media screen and (max-width: 749px) {
          /* Header icons mobile styles */
          .header__icon {
            display: flex !important;
            padding: 8px !important;
            margin: 0 2px !important;
            pointer-events: auto !important;
            cursor: pointer !important;
            z-index: auto !important;
          }
  
          #chat-widget-launcher {
            display: flex !important;
            padding: 8px !important;
            margin: 0 5px !important;
            pointer-events: auto !important;
          }
  
          #chat-widget-launcher .icon,
          .header__icon .icon {
            width: 20px !important;
            height: 20px !important;
            pointer-events: none !important;
          }
  
          /* Ensure proper spacing between icons */
          .header__icons {
            display: flex !important;
            align-items: center !important;
            gap: 0.25rem !important;
            pointer-events: none !important;
          }
  
          /* Ensure links within icons are clickable */
          .header__icon a,
          .header__icon.link {
            pointer-events: auto !important;
            cursor: pointer !important;
            text-decoration: none !important;
          }
  
          .header__icon--account a {
            pointer-events: auto !important;
            cursor: pointer !important;
            display: flex !important;
            align-items: center !important;
          }
        }
  
        @media screen and (min-width: 750px) {
          #chat-widget-launcher {
            margin-left: 0.5rem;
          }
        }
  
        /* Ensure header icons have proper z-index and no blocking elements */
        .header__icons {
          position: relative !important;
          z-index: 1001 !important;
        }
  
        .header__icon--account {
          position: relative !important;
          z-index: 1002 !important;
        }
  
        /* Remove any potential overlays that might block clicks */
        .header__icon::before,
        .header__icon::after {
          display: none !important;
        }
  
        /* Don't interfere with BobWebExt default positioning */
        /* Remove any custom positioning that might conflict */
      `;
      document.head.appendChild(style);
    }
  
    // Don't enforce custom positioning - let BobWebExt handle it
  }
  
  /**
   * Don't enforce custom positioning - let BobWebExt handle defaults
   */
  
  /**
   * Toggle chat widget open/close
   */
  function toggleChatWidget() {
    const chatLauncher = document.getElementById('chat-widget-launcher');
    if (!chatLauncher) return;
  
    const chatWidgetId = chatLauncher.dataset.widgetId;
    if (!chatWidgetId || chatWidgetId === 'YOUR_EXTENSION_ID') {
      console.warn('Chat widget ID not configured');
      return;
    }
  
    if (typeof window.BobWebExt === 'undefined') {
      console.warn('BobWebExt not found');
      return;
    }
  
    const widget = window.BobWebExt[chatWidgetId];
  
    if (!widget) {
      console.warn(`Chat widget with ID '${chatWidgetId}' not found.`);
      return;
    }
  
    // Use ready() to ensure widget is loaded before toggling
    widget.ready((instance) => {
      instance.toggle();
      // Let BobWebExt handle positioning naturally
    });
  }
  
  /**
   * Removed - letting BobWebExt handle default positioning
   */
  
  /**
   * Open chat widget
   */
  function openChatWidget() {
    const chatLauncher = document.getElementById('chat-widget-launcher');
    if (!chatLauncher) return;
  
    const chatWidgetId = chatLauncher.dataset.widgetId;
    if (!chatWidgetId || chatWidgetId === 'YOUR_EXTENSION_ID') {
      console.warn('Chat widget ID not configured');
      return;
    }
  
    if (typeof window.BobWebExt === 'undefined') return;
  
    const widget = window.BobWebExt[chatWidgetId];
    if (!widget) return;
  
    widget.ready((instance) => {
      instance.open();
    });
  }
  
  /**
   * Close chat widget
   */
  function closeChatWidget() {
    const chatLauncher = document.getElementById('chat-widget-launcher');
    if (!chatLauncher) return;
  
    const chatWidgetId = chatLauncher.dataset.widgetId;
    if (!chatWidgetId || chatWidgetId === 'YOUR_EXTENSION_ID') {
      console.warn('Chat widget ID not configured');
      return;
    }
  
    if (typeof window.BobWebExt === 'undefined') return;
  
    const widget = window.BobWebExt[chatWidgetId];
    if (!widget) return;
  
    widget.ready((instance) => {
      instance.close();
    });
  }
  
  // Initialize when DOM is ready
  document.addEventListener('DOMContentLoaded', initChatWidget);
  
  // Also initialize if DOM is already loaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initChatWidget);
  } else {
    initChatWidget();
  }
  
  // Fix login button functionality
  function fixLoginButton() {
    const loginButton = document.querySelector('.header__icon--account a');
    if (loginButton) {
      // Remove any event listeners that might interfere
      loginButton.style.pointerEvents = 'auto';
      loginButton.style.cursor = 'pointer';
      loginButton.style.position = 'relative';
      loginButton.style.zIndex = '1000';
  
      // Add click event listener as fallback
      loginButton.addEventListener('click', function(e) {
        console.log('Login button clicked');
        // Remove any overlay that might be blocking
        const overlays = document.querySelectorAll('[style*="position: fixed"], [style*="z-index"]');
        overlays.forEach(overlay => {
          if (overlay.style.zIndex > 999 && overlay !== loginButton) {
            console.log('Found potential blocking overlay:', overlay);
          }
        });
      });
  
      console.log('Login button fixed:', loginButton.href);
    }
  }
  
  // Initialize login button fix
  setTimeout(fixLoginButton, 1000);
  document.addEventListener('DOMContentLoaded', fixLoginButton);
  
  // Make functions globally accessible
  window.toggleChatWidget = toggleChatWidget;
  window.openChatWidget = openChatWidget;
  window.closeChatWidget = closeChatWidget;